var exports = {
  "kL": "AttachmentFile.module__container___XzdUck",
  "G5": "AttachmentFile.module__deleteButton___XzdUck",
  "Dq": "AttachmentFile.module__attachmentContainer___XzdUck",
  "zc": "AttachmentFile.module__iconContainer___XzdUck",
  "el": "AttachmentFile.module__fileInfoContainer___XzdUck",
  "Md": "AttachmentFile.module__fileName___XzdUck",
  "m$": "AttachmentFile.module__fileNameTruncate___XzdUck",
  "i_": "AttachmentFile.module__fileExtension___XzdUck",
  "Ov": "AttachmentFile.module__fileSize___XzdUck",
  "l6": "AttachmentFile.module__downloadButton___XzdUck",
  "Hj": "AttachmentFile.module__downloadButtonDisabled___XzdUck",
};

module.exports = exports;
